// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetManagementTestingAreaId } from './FleetManagementTestingAreaId'
import { FleetManagementTestingAreaNavigation } from './FleetManagementTestingAreaNavigation'
import { FleetManagementTestingAreaRoutes } from './FleetManagementTestingAreaRoutes'

const LazyFleetManagementTestingComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./FleetManagementTestingArea')),
)

const FleetManagementTestingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetManagementTestingComponent />
  </SuspenseLoadingWrapper>
)

export const FleetManagementTestingArea = {
  id: FleetManagementTestingAreaId,
  requiredRight: BoumRight.AREA_VEHICLE,
  NavigationComponent: FleetManagementTestingAreaNavigation,
  route: {
    path: FleetManagementTestingAreaRoutes.route,
    component: FleetManagementTestingComponent,
  },
}
